'use client';

import { createContext } from 'react';

import type { ProvidedDataShape } from './types';

export const DataProviderContext = createContext<ProvidedDataShape | undefined>(
  undefined,
);

export const DataProviderContextProvider = ({
  children,
  value,
}: {
  children: React.ReactNode;
  value: ProvidedDataShape;
}) => (
  <DataProviderContext.Provider value={value}>
    {children}
  </DataProviderContext.Provider>
);
